async function getServicesAbout() {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/services-about-pages`,
    );
    return response.json();
  } catch (error) {
    throw new Error(error.message);
  }
}

export default getServicesAbout;
